import 'css-chunksrc/client/scenes/wbs/tags/form/styles.scss';export default {
  "form": "_form_fjjoz_1",
  "main": "_main_fjjoz_8",
  "input": "_input_fjjoz_18",
  "button": "_button_fjjoz_32",
  "list": "_list_fjjoz_45",
  "item": "_item_fjjoz_51",
  "tagBadge": "_tagBadge_fjjoz_60"
};